import _ from 'lodash'

const DEFAULT_COLUMNS = [
  { key: 'Kontraktnr', default: '', name: 'Kontraktnr', sortKey: 'Kontraktnr', class: 'sorttable_numeric', readonly: true, selected: true },
  { key: 'Lopenr', default: '', name: 'Løpenr', sortKey: 'Lopenr', class: 'sorttable_numeric', readonly: true, selected: true },
  { key: 'Kategori', default: '-', name: 'Kat.', sortKey: 'Kategori', class: '', selected: true },
  { key: 'Auksjon', default: '-', name: 'Auksjon', sortKey: 'Auksjon', class: '', selected: true },
  { key: 'Katalogtekst', default: '-', name: 'Tittel', sortKey: 'Katalogtekst', class: 'main-text align-left', tooltip: true, selected: true },
  { key: 'Minstepris', default: '', name: 'Minstepris', sortKey: 'Minstepris', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Vurderinglav', default: '', name: 'Lav', sortKey: 'Vurderinglav', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Tilslag', default: '', name: 'Tilslag', sortKey: 'Tilslag', class: 'align-left', filter: 'integer', selected: true },

  { key: 'Kjoper', default: '-', name: 'Kjøper #', sortKey: 'Kjoper', class: '', selected: true },
  { key: 'parsed_name', default: '-', name: 'Kjøper', sortKey: 'Fnavn', class: '', selected: true },

  { key: 'sort-1', default: '', name: 'Sortering 1', sortKey: '', class: 'unsortable align-left', filter: '', selected: true },
  { key: 'sort-2', default: '', name: 'Sortering 2', sortKey: '', class: 'unsortable align-left', filter: '', selected: true },
  { key: 'sort-3', default: '', name: 'Sortering 3', sortKey: '', class: 'unsortable align-left', filter: '', selected: true },
  { key: 'sort-4', default: '', name: 'Sortering 4', sortKey: '', class: 'unsortable align-left', filter: '', selected: true }
]

const LS_KEY = 'winereport-search-values'
const LS_KEY_COLS = 'columns'

const state = {
  defaultColumns: null
}

const loadLs = (key = null) => {
  try {
    const retval = JSON.parse(localStorage.getItem(LS_KEY) || {})

    if (key === null) {
      return retval
    }

    if (!retval.hasOwnProperty(key)) {
      return null
    }

    return retval[key]
  } catch (e) {
    return null
  }
}

const saveLs = (key, data) => {
  try {
    const stored = loadLs() || {}
    stored[key] = data
    localStorage.setItem(LS_KEY, JSON.stringify(stored))
  } catch (e) {
    // Ignore
  }
}

const getters = {
  columns: state => {
    if (!state.defaultColumns) {
      let retval = loadLs(LS_KEY_COLS) || DEFAULT_COLUMNS

      // How we get possibly new cols added...
      if (retval !== DEFAULT_COLUMNS) {
        retval = _.uniqBy([...retval, ...DEFAULT_COLUMNS], 'key')
      }

      return retval
    }

    return state.defaultColumns
  }
}

const actions = {
  saveColumns: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveColumns', payload)
      resolve()
    })
  },
  resetColumns: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit('resetColumns')
      resolve()
    })
  }
}

const mutations = {
  'saveColumns': (state, payload) => {
    state.defaultColumns = payload
    saveLs(LS_KEY_COLS, payload)
  },
  'resetColumns': (state) => {
    state.defaultColumns = DEFAULT_COLUMNS
    saveLs(LS_KEY_COLS, DEFAULT_COLUMNS)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/winereport.js